import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Tab, Nav } from "react-bootstrap";
import "./styles.css";

const Tabs = ({ tabList = [] }) => {
    const location = useLocation();
    const navigate = useNavigate();

    const getInitialTab = () => {
        const hash = location.hash.replace('#', '');
        return tabList.find(tab => tab.key === hash)?.key || tabList[0]?.key;
    };

    const [activeTab, setActiveTab] = useState(getInitialTab());

    const handleTabChange = (selectedKey) => {
        setActiveTab(selectedKey);
        navigate(`#${selectedKey}`, { replace: true });
    };

    // Set default hash if none present
    useEffect(() => {
        if (!location.hash && tabList.length > 0) {
            navigate(`#${tabList[0].key}`, { replace: true });
        }
    }, [location.hash, tabList]);

    // Update activeTab when hash changes
    useEffect(() => {
        const hash = location.hash.replace('#', '');
        if (hash && hash !== activeTab) {
            setActiveTab(hash);
        }
    }, [location.hash]);

    return (
        <Tab.Container activeKey={activeTab} onSelect={handleTabChange}>
            <Nav variant="tabs" className="flex-row mb-3">
                {tabList.map((tab, index) => (
                    <Nav.Item key={index}>
                        <Nav.Link eventKey={tab.key}>
                            {tab.label}
                        </Nav.Link>
                    </Nav.Item>
                ))}
            </Nav>

            <Tab.Content>
                {
                    tabList.map((tab, index) => (
                        <Tab.Pane eventKey={tab.key} key={index}>
                            {activeTab === tab.key && (
                                typeof tab.content === "function" ? tab.content() : tab.content
                            )}
                        </Tab.Pane>
                    ))
                }
            </Tab.Content>
        </Tab.Container>
    );
};

export default Tabs;
